export default "__VITE_ASSET__D_C6WuhR__"